export default __webpack_public_path__ + "static/media/ic_prescribir_medicamento.b04a5410.svg";